"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withOverrides = void 0;
const overrideUtils_1 = require("./overrideUtils");
const typeGuards_1 = require("./typeGuards");
function overriddenGetter(getter, overrides, typeGuard) {
    return (name, context) => {
        if (overrideUtils_1.overrideExists(name, overrides)) {
            const override = overrides[name];
            if (typeGuard(override)) {
                return override;
            }
            // tslint:disable-next-line:no-console
            console.warn(`Warning: ignoring override for ${name} due to mismatched type.`, `Override type ${typeof override} does not match ${getter.name}.`, `Falling back to the existing interpreter config.`);
        }
        return getter(name, context);
    };
}
exports.withOverrides = (interpreter, overrides) => {
    if (!overrides) {
        return interpreter;
    }
    return {
        featureFlag: (name, on, off, context) => {
            if (overrideUtils_1.overrideExists(name, overrides)) {
                const override = overrides[name];
                if (typeGuards_1.isBoolean(override)) {
                    return overrides[name] ? on() : off();
                }
                // tslint:disable-next-line:no-console
                console.warn(`Warning: ignoring override for ${name} due to mismatched type.`, `Override type ${typeof override} does not match ${typeGuards_1.isBoolean.name}.`, `Falling back to the existing interpreter config.`);
            }
            return interpreter.featureFlag(name, on, off, context);
        },
        getBoolean: overriddenGetter(interpreter.getBoolean.bind(interpreter), overrides, typeGuards_1.isBoolean),
        getString: overriddenGetter(interpreter.getString.bind(interpreter), overrides, typeGuards_1.isString),
        getFloat: overriddenGetter(interpreter.getFloat.bind(interpreter), overrides, typeGuards_1.isFloat),
        getInt: overriddenGetter(interpreter.getInt.bind(interpreter), overrides, typeGuards_1.isInteger),
        getJson: overriddenGetter(interpreter.getJson.bind(interpreter), overrides, typeGuards_1.isJson),
    };
};
//# sourceMappingURL=OverriddenInterpreter.js.map